export default {
  headerStyles: {
    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "space-between" as "space-between",
  },

  infoContainerStyles: {
    display: "flex",
    flexDirection: "column" as "column",
    justifyContent: "space-between" as "space-between",
  },

  nameStyles: {
    fontSize: "x-large",
  },

  imageStyles: {
    height: "8rem",
    width: "8rem",
  },

  iconStyles: {
    height: "2rem",
    width: "2rem",
    margin: "0 0.5rem 0 0",
  },

  iconContainerStyles: {
    display: "flex",
  },
};
